/**
 * Accordion toggle for [data-accordion] > [data-accordion-item] > [data-accordion-trigger],
 * panel [data-accordion-item] .accordion__content. Open state is carried solely by
 * .accordion__item--open, which slide() must set only after measuring the start height.
 */
(function () {
  'use strict';

  var DURATION = 400;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var OPEN = 'accordion__item--open';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reflow(el) {
    return el.offsetHeight;
  }

  function clearInline(content) {
    content.style.transition = '';
    content.style.height = '';
    if (content.accordionTimer) {
      window.clearTimeout(content.accordionTimer);
      content.accordionTimer = null;
    }
    if (content.accordionEnd) {
      content.removeEventListener('transitionend', content.accordionEnd);
      content.accordionEnd = null;
    }
  }

  function onceSettled(content, done) {
    content.accordionEnd = function (e) {
      if (e.target !== content || e.propertyName !== 'height') {
        return;
      }
      done();
    };
    content.addEventListener('transitionend', content.accordionEnd);
    // transitionend never fires for a panel that gets hidden while it animates
    content.accordionTimer = window.setTimeout(done, DURATION + 50);
  }

  function slide(item, content, open) {
    var start = content.getBoundingClientRect().height;

    clearInline(content);

    if (prefersReducedMotion()) {
      item.classList.toggle(OPEN, open);
      return;
    }

    content.style.height = start + 'px';
    reflow(content);

    item.classList.toggle(OPEN, open);

    content.style.transition = 'height ' + DURATION + 'ms ' + EASING;
    content.style.height = (open ? content.scrollHeight : 0) + 'px';

    onceSettled(content, function () {
      clearInline(content);
    });
  }

  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        var content = item && item.querySelector('.accordion__content');
        if (!content) {
          return;
        }
        var open = trigger.getAttribute('aria-expanded') !== 'true';

        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-hidden', open ? 'false' : 'true');
        slide(item, content, open);
      });
    });
  });
})();
